require('./style.less');

var BaseShapeView = require('../baseShapePropertyView'),
    RedactionZonePropertiesView = require('../../../../../canvas/views/shape/redaction/dialog/redactionProperties');

/**
 * Now kinda like abstract class.
 * It's now just a wrapper for the actual redaction zone dialog view.
 */


module.exports = BaseShapeView.extend({

    className: 'fr-redaction-zone-properties',

    template: require('./template.hbs'),

    regions: _.extend( {}, BaseShapeView.prototype.regions, {

        redactionZonePropertiesRegion: '.fr-redaction-zone-properties-region'

    } ),

    onBeforeShow: function() {

        this.redactionZonePropertiesRegion.show( new RedactionZonePropertiesView( this.dialogOptions() ) );
    },

    dialogOptions: function() {

        return {
            renderDisabled: this.renderDisabled,
            shapeModel: this.shape
        };

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/shapeProperties/redaction/baseView.js
 ** module id = 605
 ** module chunks = 0
 **/